import { render, staticRenderFns } from "./DriverMileage.vue?vue&type=template&id=7308979a&scoped=true"
import script from "./DriverMileage.vue?vue&type=script&lang=js"
export * from "./DriverMileage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7308979a",
  null
  
)

export default component.exports